import styled, {css} from 'styled-components';
import Avatar from './Avatar';

const AVATAR_WIDTH = 50;

const userCardStyles = css`
display: grid;
grid-template-columns: ${AVATAR_WIDTH}px auto;
gap: 0px;
border: 1px solid gray;
border-radius: 3px;
padding: 5px;
text-align: left;
flex: 1;
overflow: hidden;

&.selected {
  border: 2px solid blue;
  font-weight: bold;
}

  & .avatar {
    width: ${AVATAR_WIDTH}px;
    height: ${AVATAR_WIDTH}px;
  }

  & .details {
    display: flex;
    flex-direction: column;
    gap: 5px;
    justify-content: center;
  }
  & .name {
    display: flex;
    flex-wrap: wrap;
  }
  & .email {
    display: flex;
    flex-wrap: wrap;
    word-break: break-word;
  }

`;
const UserCard = styled(({ className, user }) => {
  return <div className={className}>
    <div className='avatar'>
      <Avatar width = {AVATAR_WIDTH} src={user.avatar} />
    </div>
    <div className='details'>
      <div className='name'>
        {`${user.firstname} ${user.lastname}`}
      </div>
      <div className='email'>
        {user.email}
      </div>
    </div>

  </div>
})`${userCardStyles}`;

export default UserCard;